import React from 'react' 
import { graphql, StaticQuery, Link } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'

const StyledUnderline = styled.div`
  width: 50px;
  height: 4px;
  background: #2c5282;
  margin-top: 50px;
  margin-bottom: 22px;
`

const PageContactSection = () => (
  <StaticQuery 
    query={query}
    render={
      data => {
        const imageDataOne = data.imageOne.childImageSharp.fluid

        return (
          <div className="bg-gray-200">
            <div className="lg:w-10/12 mx-auto py-20 sm:py-6 sm:px-4 md:py-12 md:px-8">
              <h2 className="font-display text-gray-900 text-3xl sm:text-2xl leading-snug mb-6">
                Corporate Office Information
              </h2>

              <p className='text-xl text-gray-900 ml-4'>
                <strong>Phone:</strong> <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a><br/>
                <strong>Phone:</strong> <a href='tel:800-714-0200' className='underline'>(800) 714-0200</a><br/>
                <strong>Fax:</strong> (714) 894-5643<br/>
              </p>

              <div className="lg:flex block">
                <div className="lg:w-1/2 w-full">
                  <StyledUnderline></StyledUnderline>
                  <h3 className="font-display text-gray-900 text-2xl mb-2 font-bold">
                    Interpacific Asset Management - Orange County
                  </h3>

                  <p className="text-xl text-gray-900 mb-6">
                    5505 Garden Grove Blvd., Suite 150
                    <br />
                    Westminster, CA 92683
                  </p>
                </div>                        
              </div>

              <div>
                <Img fluid={imageDataOne} alt='Google map directions for Interpacific Asset Management' className='w-9/12 sm:w-full shadow-lg' />
              </div>

              <StyledUnderline></StyledUnderline>

              <h2 className="font-display text-gray-900 text-3xl sm:text-2xl leading-snug mb-6">
                How may we be of assistance?
              </h2>

              <div className='w-9/12 sm:w-full ml-4 sm:pr-4'>
                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>To Request Information</h3>
                <p className='text-xl text-gray-900 mb-6'>If you are interested in receiving more information about the many services offered by Interpacific Asset Management, you may call us at <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a> or <Link to='/request-info' className='font-bold underline'>click here</Link> to email us. Please include the best time and place for us to contact you.</p>

                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>Maintenance Requests</h3>
                <p className='text-xl text-gray-900 mb-6'>To request a repair or to report any property damage please call us at <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a> or <Link to='/request-service' className='underline'>click here</Link> to submit a maintenance request on-line.</p>

                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>24 Hour Emergencies</h3>
                <p className='text-xl text-gray-900 mb-6'>For assistance with any life/safety issues or property-threatening emergencies, please call 911. If the emergency is not life-threatening please call us at <a href='tel:800-408-3469' className='underline'>(800) 408-3469</a>, 24 hours a day, 7 days a week.</p>

                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>Account Inquiries</h3>
                <p className='text-xl text-gray-900 mb-6'>For questions about your billing statement, or to obtain a copy of your statement or an account history, please call us at <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a>, fax us at (714) 894-5643, or <Link to='/request-info' className='font-bold underline'>click here</Link> to email us.</p>

                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>Leasing Information</h3>
                <p className='text-xl text-gray-900 mb-6'>If you would like information about leasing a specific property (commercial, industrial or residential), please call <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a> between the hours of 8:30 am and 5:00 pm, Monday through Friday. Be prepared to state your name, telephone number, and the location of the property you are interested in.</p>

                <h3 className='font-display text-gray-900 text-2xl mb-2 font-bold'>HOA Escrow Documents</h3>
                <p className='text-xl text-gray-900 mb-6'>For any questions or requests concerning escrows, or to request documents you need to sell or refinance your home, please call us at <a href='tel:714-891-8804' className='underline'>(714) 891-8804</a> or <Link to='/request-info' className='font-bold underline'>click here</Link> to email us. (Please note that there is a minimum of a 48-hour turn-around time for documents to be prepared. We also request that escrow document fees be paid in advance. A rush option is also available for an additional fee.)</p>
              </div>
            </div>
          </div>
        )
      }
    }
  />
)

export default PageContactSection

const query = graphql`
  query PageContactSectionQuery {
    imageOne: file(relativePath: { eq: "header/iam-map-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 959) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`